import './Gifts.css';
import '../index.css'
import { useState } from "react";
import useSWR from 'swr';
import { fetcher } from "../lib/fetcher.js";
import Gift from "../components/Gift.js";
import AlertModal from '../components/AlertModal';
import Spacer from '../components/Spacer.js'

function Gifts() {
    const [reservePopup, setReservePopup] = useState(false);
    const [undoPopup, setUndoPopup] = useState(false);
    const [activeGift, setActiveGift] = useState(null);
    const [password, setPassword] = useState("");

    const [showReserveErrorAlert, setShowReserveErrorAlert] = useState(false);
    const [showReserveAlert, setShowReserveAlert] = useState(false);
    const [showUndoReserveErrorAlert, setShowUndoReserveErrorAlert] = useState(false);
    const [ShowUndoReserveAlert, setShowUndoReserveAlert] = useState(false);

    const { data } = useSWR('/api/reserve', fetcher)

    const handleReserve = async () => {
        const result = await fetch('/api/reserve', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ gift_name: activeGift.gift_name, amount: activeGift.amount, password: password }),
        })

        if (result.status !== 200) {
            setShowReserveErrorAlert(true);
        } else {
            setShowReserveAlert(true);
        }
        setReservePopup(false);
    }

    const handleUndo = async () => {
        const result = await fetch('/api/reserve', {
            method: 'DELETE',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ gift_name: activeGift.gift_name, password: password }),
        })


        if (result.status !== 200) {
            setShowUndoReserveErrorAlert(true);
        } else {
            setShowUndoReserveAlert(true);
        }
        setUndoPopup(false);
    }

    const handleReserveClick = (gift, amount) => {
        setActiveGift({ ...gift, amount });
        setReservePopup(true)
    }

    const handleUndoClick = (gift) => {
        setActiveGift({ ...gift });
        setUndoPopup(true)
    }

    const allGifts = data?.data || [];
    const { gifts, reservedGifts } = allGifts.reduce((acc, gift) => {
        if (gift.remaining > 0) {
            acc.gifts.push(gift)
        } else {
            acc.reservedGifts.push(gift);
        }
        return acc
    }, { gifts: [], reservedGifts: [] })

    return (
        <div className='home-main'>
            {reservePopup && <div className="popup-wrapper" >
                <div className='popup-card-wrapper'>
                    <div className="popup-card">
                        <div className='popup-close-button-container'>
                            <button className='popup-close-button' onClick={() => setReservePopup(false)}>
                                ✘
                            </button>
                        </div>
                        <p className="home-text">Vänligen ange lösenord för din reservation (För att kunna ångra senare)</p>
                        <input
                            type="password"
                            className="popup-input"
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Lösenord..."
                            onKeyDown={(e) => e.key === 'Enter'}
                        />
                        <button className="popup-button" onClick={handleReserve}>Reservera</button>
                    </div>
                </div>
            </div>}
            {undoPopup && <div className="popup-wrapper" >
                <div className='popup-card-wrapper'>
                    <div className="popup-card">
                        <div className='popup-close-button-container'>
                            <button className='popup-close-button' onClick={() => setUndoPopup(false)}>
                                ✘
                            </button>
                        </div>
                        <p className="home-text">Vänligen ange ditt lösenord får att ångra din reservation</p>
                        <input
                            type="password"
                            className="popup-input"
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Lösenord..."
                            onKeyDown={(e) => e.key === 'Enter'}
                        />
                        <button className="popup-button" onClick={handleUndo}>Ångra</button>
                    </div>
                </div>
            </div>}
            <p className='home-main-text'>Gåvor</p>
            <Spacer />
            <div className='gifts-container'>
                <div className='gifts-inner-container'>
                    <p className='card-text'>Din närvaro är allt vi önskar. Men vill ni ändå uppmärksamma vår dag med en gåva har vi en önskelista. Om du planerar att ge oss något, reservera det nedan så köper inte du och någon annan gäst samma sak. För att kunna ångra en reservation så kan du ange ett lösenord när du reserverar.</p>
                    <p className='card-text'>Listan är bara till för att underlätta för er, och det går självklart bra att köpa något annat också. Vill ni hellre ge ett bidrag till vår bröllopsresa så går det bra att skicka en swish till 072-8580546, märkt med "Bröllopsresa".</p>
                    <div className='reserve-line' />
                    {gifts.map((gift) => <Gift key={gift.gift_name} gift={gift} handleReserveClick={handleReserveClick} handleUndoClick={handleUndoClick} />)}
                    <div className='reserve-line' />
                </div>
            </div>
            {
                reservedGifts.length > 0 &&
                <div>
                    <p className='home-main-text'>Reserverade Gåvor</p>
                    <div className='gifts-container'>
                        <div className='gifts-inner-container'>
                            {reservedGifts.map((gift) => <Gift key={gift.gift_name} gift={gift} handleReserveClick={handleReserveClick} handleUndoClick={handleUndoClick} />)}
                            <div className='reserve-line' />
                        </div>
                    </div>
                </div>
            }
            <AlertModal
                isOpen={showReserveErrorAlert}
                title="Något gick fel"
                message="Det gick inte att spara din reservation. Vänligen försök igen."
                confirmText="OK"
                onConfirm={() => setShowReserveErrorAlert(false)}
            />
            <AlertModal
                isOpen={showReserveAlert}
                title="Reservation sparad"
                message={`${activeGift?.amount} st ${activeGift?.gift_name} reserverad${activeGift?.amount > 1 ? "e" : ""}!`}
                confirmText="OK"
                onConfirm={() => setShowReserveAlert(false)}
            />
            <AlertModal
                isOpen={showUndoReserveErrorAlert}
                title="Felaktigt lösenord"
                message="Vänligen försök igen."
                confirmText="OK"
                onConfirm={() => setShowUndoReserveErrorAlert(false)}
            />
            <AlertModal
                isOpen={ShowUndoReserveAlert}
                title="Reservation tillbakadragen"
                message={`Reservation för ${activeGift?.gift_name} tillbakadragen.`}
                confirmText="OK"
                onConfirm={() => setShowUndoReserveAlert(false)}
            />
            <Spacer />
        </div >
    );
}

export default Gifts;
